import React from 'react';
import styles from './ProjectsPanel.module.scss';
import type { FC } from 'react';
import { ChevronRightIcon } from '../../assets/icons/icons';
import { STATUS_META } from '../../data/projectsTable';
import type { Project } from '../../types/projectsTable';
import { formatDate, formatRub } from '../../utils/format';
import { Loading } from '../../components/ui/Loading/Loading';

interface ProjectsPanelProps {
    projects: Project[];
    isLoading: boolean;
    onOpenSection: () => void;
    onProjectMenu: (project: Project) => void;
}

export const ProjectsPanel: FC<ProjectsPanelProps> = ({
    projects,
    isLoading,
    onOpenSection,
    onProjectMenu,
}) => (
    <section className={styles.panel}>
        <div className={styles.head}>
            <h2>Последние проекты</h2>
        </div>

        <div className={styles.table}>
            <div className={styles.scroll} aria-label="Последние проекты">
                {isLoading && <Loading text="Загружаем проекты…" className={styles.loading} />}

                {!isLoading && projects.length === 0 && (
                    <p className={styles.hint}>Проектов пока нет. Создайте первый.</p>
                )}

                {projects.map((project) => (
                    <button
                        type="button"
                        className={styles.row}
                        key={project.id}
                        aria-label={`Открыть проект «${project.name}»`}
                        onClick={() => onProjectMenu(project)}
                    >
                        <div>
                            <b>{project.name}</b>
                            <small>
                                {formatDate(project.date)} · {project.author}
                            </small>
                        </div>

                        <div>
                            <div className={styles.label}>Цена</div>
                            <div className={styles.value}>{formatRub(project.price)}</div>
                        </div>

                        <div>
                            <div className={styles.label}>Логистика</div>
                            <div className={styles.value}>{formatRub(project.logistics)}</div>
                        </div>

                        <div>
                            <div className={styles.label}>Позиции</div>
                            <div className={styles.value}>
                                {project.done} / {project.total}
                            </div>
                        </div>

                        <div className={`${styles.status} ${styles[project.status]}`}>
                            {STATUS_META[project.status].label}
                        </div>

                        <span className={styles.more} aria-hidden="true">
                            <ChevronRightIcon />
                        </span>
                    </button>
                ))}

            </div>
        </div>

        <div className={styles.footer}>
            <button type="button" className={styles.allButton} onClick={onOpenSection}>
                Перейти в раздел «Проекты»
                <ChevronRightIcon />
            </button>
        </div>
    </section>
);
